import { ExpandButton as FellesExpandButton } from "@sb1f/buttons";
import type { ExpandButtonProps } from "@sb1/ffe-buttons-react";
import { getCustomData } from "~/utils/tracking/utils";

type Props = ExpandButtonProps & {
	track?: boolean;
	knappNavn?: string;
	trackingData?: object;
};

const ExpandButton = ({ track = true, trackingData, ...props }: Props) => {
	const customData = trackingData ? { ...trackingData, ...getCustomData() } : getCustomData();
	return <FellesExpandButton customData={customData} {...props} />;
};

export default ExpandButton;
